import "./App.css";
import Navbar from "./Components/Navbar";
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home1 from "./pages/Home1";
import Home from "./pages/Home";
import { useAuth } from "./Components/Authcontext";
import Login from "./pages/Login";

function App() {
  const { isAuthenticated } = useAuth();
  return (
    <Router>
      <Routes>
       


        {!isAuthenticated ? (
          <>
          <Route path="/*" element={<Login />} />
          </>
        ) : (
          <>
            <Route path="/" element={<Home />} />
            {/* <Route path="/attendance" element={<Attendance />} /> */}
          </>
        )}
      </Routes>
    </Router>
  );
}

export default App;
